import React, { Component } from 'react';
import Header from './../../containers/HeaderContainer';
import GameWrapperContainer from '../../containers/GameWrapperContainer';
import MailListContainer from '../../containers/mailListContainer/MailListContainer';
import MailHeaderContainer from '../../containers/mailHeaderContainer';
import Footer from './../../containers/FooterContainer';
import analyticsUtil from '../../utils/segmentUtils';

class TutorialScreen extends Component {

    constructor(props) {
        super(props);
        this.state = {
            height: 0
        };
    }

    componentDidMount() {
        analyticsUtil.page('Tutorial page')
    }

    render() {
        // const { run, sidebarOpen, steps, stepIndex } = this.state;
        const isMailThreadView = false;
        // console.log(this.props);

        return <GameWrapperContainer match={this.props.match}>
            <Header />
            <div className="mail-container"            >
                <MailHeaderContainer match={this.props.match} isMailThreadView={isMailThreadView} />
                <MailListContainer {...this.props} />
            </div>
            <Footer {...this.props} />
        </GameWrapperContainer>;
    }
}
export default TutorialScreen;


// WEBPACK FOOTER //
// /src/screens/Tutorial/index.js